// extracted by mini-css-extract-plugin
export var legendIndicator = "_gt-1";
export var legendRight = "_gt-0";